import Link from 'next/link'

export default function ErrorPage() {
	return (
		<div className=' flex items-center justify-center'>
			<div className='text-center w-full max-w-7xl h-screen relative'>
				<div className='flex flex-col items-center lg:items-start lg:flex-row gap-10 lg:gap-0 lg:justify-between absolute w-full xl:bottom-32 top-0 xl:top-auto px-4'>
					<p className='text-center lg:text-start max-w-[360px] font-extralight text-3xl text-medante-purple-dark'>
						Ups, zdá sa, že náš web potrebuje preventívnu prehliadku
					</p>
					<div className='max-w-[420px] flex flex-col items-center lg:items-start'>
						<p className='text-center lg:text-start font-extralight text-base lg:text-lg mb-7 text-medante-purple-dark'>
							Kým budeme hľadať symptómy stránky, vy zatiaľ spoznajte náš celostný
							prístup k zdraviu a prejdite na Domov.
						</p>
						<Link
							href='/'
							title='Domov'
							className='btn_basic wmin200 mgt-40 mgt-30lg'
							aria-label='Domov'
							prefetch={false}
						>
							<span>Domov</span>
							<span aria-hidden='true'>
								<span>
									<svg className='sico' aria-hidden='true'>
										<use href='/assets/layout/icons.svg#s_ar2_r' />
									</svg>
								</span>
								<span>
									<svg className='sico' aria-hidden='true'>
										<use href='/assets/layout/icons.svg#s_ar2_r' />
									</svg>
								</span>
							</span>
						</Link>
					</div>
				</div>
			</div>
		</div>
	)
}
